import { actionTypes } from "../actions/types"
const userLocal = localStorage.getItem('idToken')
const resultLocal = JSON.parse(userLocal)

export const initialStateApp = {
    user: null || resultLocal,
    consumoData: null

}
const reducerApp = (state, action) => {
    switch (action.type) {
        case actionTypes.USER_AUTH:
            return {
                ...state,
                user: action.payload
            }
        case actionTypes.CONSUMO_DATE:
            return {
                ...state,
                consumoData: action.payload
            }
        default: return state
    }

}

export default reducerApp